// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__2HjR7","balanceDisclaimer":"posDashboard_balanceDisclaimer__1vCQO"};